module.exports = xor;
function xor(a, b) {
  var len = Math.min(a.length, b.length);
  var out = new Buffer(len);
  var i = -1;
  while (++i < len) {
    out.writeUInt8(a[i] ^ b[i], i);
  }
  return out;
}


//////////////////
// WEBPACK FOOTER
// ./~/browserify-aes/xor.js
// module id = 483
// module chunks = 0